module.exports = __webpack_public_path__ + "img/przelewy24.ae41daaf.png";